import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/VendorSearch'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class VendorSearchStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "VendorSearchStore",
			variables: false,
		})
	}
}

export async function load_VendorSearch(params) {
  await initClient()

	const store = new VendorSearchStore()

	await store.fetch(params)

	return {
		VendorSearch: store,
	}
}
